import React from 'react';
import { MasterAdminSettings } from '../organisms';
import { SettingsTemplate } from '../templates';

export function MasterAdminSettingsPage() {
  return (
    <SettingsTemplate>
      <MasterAdminSettings />
    </SettingsTemplate>
  );
}
